type colorsType = {
  primary: string;
  primaryColor: string;
  primaryHeader: string;
  primaryHeaderColor: string;
  secondary: string;
  secondaryColor: string;
  secondaryHeader: string;
  secondaryHeaderColor: string;
  background: string;
};

/**
 * Хук для перекраски страниц партнёров в их цвета
 */

export const setPageColors = ({
  primary,
  primaryColor,
  primaryHeader,
  primaryHeaderColor,
  secondary,
  secondaryColor,
  secondaryHeader,
  secondaryHeaderColor,
  background,
}: colorsType) => {
  const r: HTMLElement | null = document.querySelector(':root');
  r?.style.setProperty('--primary', primary);
  r?.style.setProperty('--primary-header', primaryHeader);
  r?.style.setProperty('--secondary', secondary);
  r?.style.setProperty('--secondary-header', secondaryHeader);
  r?.style.setProperty('--primary-color', primaryColor);
  r?.style.setProperty('--primary-header-color', primaryHeaderColor);
  r?.style.setProperty('--secondary-color', secondaryColor);
  r?.style.setProperty('--secondary-header-color', secondaryHeaderColor);
  r?.style.setProperty('--partner-background', background);
};
